import React from "react";
import { of } from "rxjs";
import { catchError, startWith } from "rxjs/operators";
import ErrorPage from "../../components/ErrorPage";
import LoadingIndicatorOverlay from "../../components/LoadingIndicatorOverlay";

export default createComponent => {
  try {
    const observable = createComponent();
    return observable.pipe(
      startWith(<LoadingIndicatorOverlay />),
      catchError(err => {
        return of(<ErrorPage error={err} />);
      })
    );
  } catch (err) {
    return of(<ErrorPage error={err} />);
  }
};
